<template>
  <el-dialog v-if="dataInfo !== null" :title="title" @closed="_closed" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false">
    <div style="padding: 20px;">
      <el-form ref="formRef" :model="formData" :rules="rules" label-width="100px">
        <el-form-item label="地点名称" required prop="location_name">
          <el-input v-model="formData.location_name" placeholder="请输入地点名称"></el-input>
        </el-form-item>
        <el-form-item label="地点描述">
          <el-input v-model="formData.location_desc" type="textarea" :rows="3" placeholder="请输入地点描述"></el-input>
        </el-form-item>
        <el-form-item label="所属区域">
          <el-input v-model="formData.area" placeholder="例如：一楼/办公区"></el-input>
        </el-form-item>
        <el-form-item label="保洁周期">
          <el-input-number v-model="formData.clean_cycle" :min="1" :max="30" label="保洁周期"></el-input-number>
          <div class="tips">单位：天，即每隔几天清洁一次</div>
        </el-form-item>
        <el-form-item label="标准清洁图">
          <l-upload-img v-model="formData.standard_image_url" :mini="false"></l-upload-img>
          <div class="tips">建议上传和工人拍照相同角度的照片作为标准对比图</div>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch v-model="formData.is_enabled"></el-switch>
        </el-form-item>
            <el-form-item label="地点维码" prop="assetName" v-if="dataInfo.location_id">
              <el-image style="width: 200px; height: 200px" :src="dataInfo.qrImg" :fit="fit"></el-image>
            </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_cancel">取 消</el-button>
      <el-button type="primary" @click="_submit">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import store from '@/store'
import LUploadImg from '@/lgh/components/uploadimg/src/main.vue'
export default {
  name: 'CleanLocationEdit',
  components: {
    LUploadImg
  },
  computed: {
    userInfo() {
      return store.state.userInfo
    }
  },
  data() {
    return {
      title: '',
      visible: true,
      isAdd: true,
      dataInfo: null,
      formData: {
        location_id: 0,
        enterprise_code: '',
        location_name: '',
        location_desc: '',
        area: '',
        standard_image_url: '',
        qrcode_url: '',
        qrcode_content: '',
        clean_cycle: 1,
        is_enabled: true,
        create_time: '2000-1-1',
        create_user_id: null,
        create_user_name: '',
        remark: ''
      },
      rules: {
        location_name: [
          { required: true, message: '请输入地点名称', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    if (this.dataInfo && !this.isAdd) {
      Object.assign(this.formData, this.dataInfo)
    }
  },
  mounted() {
    if (this.dataInfo && !this.isAdd) {
      Object.assign(this.formData, this.dataInfo)
    }
  },
  methods: {
    _closed() {
      this.onclosed()
    },
    _cancel() {
      this.visible = false
      this.cancel && this.cancel()
    },
    async _submit() {
      const result = await this.submit()
      if (result === true) {
        this.visible = false
        this.onsuccess && this.onsuccess(result)
      }
    },
    async submit() {
      let valid = false
      await this.$refs.formRef.validate((result) => {
        valid = result
      })
      if (!valid) {
        return false
      }

      this.formData.enterprise_code = this.userInfo.enterpriseCode
      this.formData.create_user_id = this.userInfo.userId
      this.formData.create_user_name = this.userInfo.fullName

      if (this.isAdd) {
        await this.$lgh.post('api/clean/location/add', this.formData)
      } else {
        await this.$lgh.post('api/clean/location/update', this.formData)
      }
      return true
    }
  }
}
</script>

<style scoped>
.tips {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}
</style>
